import React, { useState } from "react"
import C15tProvider from "cookiesConsent/infrastructure/c15t/runtime/C15tProvider"
import SeedDefaultConsent from "cookiesConsent/infrastructure/c15t/runtime/SeedDefaultConsent"
import ConsentUi from "cookiesConsent/infrastructure/c15t/ui/ConsentUi"
import {
  JurisdictionRules,
  PrivacySignal
} from "cookiesConsent/domain/jurisdiction"

interface C15tRuntimeProps {
  rules: JurisdictionRules
  signal: PrivacySignal
  children: React.ReactNode
}

const C15tRuntime = ({ rules, signal, children }: C15tRuntimeProps) => {
  const [settled, setSettled] = useState(false)

  return (
    <C15tProvider>
      {children}
      <SeedDefaultConsent
        rules={rules}
        signal={signal}
        onSettled={() => setSettled(true)}
      />
      {settled ? <ConsentUi /> : null}
    </C15tProvider>
  )
}

export default C15tRuntime
